module.exports = __webpack_public_path__ + "static/media/document-card-image.49891414.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/document-card-image.jpg
// module id = 757
// module chunks = 0